import { MotionConfig, useReducedMotion } from "motion/react";
import { type ReactNode, createContext, useContext } from "react";

const FullLandingMotion = createContext(false);

export function LandingMotion({ children }: { children: ReactNode }) {
  return (
    <FullLandingMotion.Provider value={true}>
      <MotionConfig reducedMotion="never">{children}</MotionConfig>
    </FullLandingMotion.Provider>
  );
}

/** The public landing always plays; shared components elsewhere retain their preference. */
export function useLandingReducedMotion() {
  const fullMotion = useContext(FullLandingMotion);
  const reduced = useReducedMotion();
  return fullMotion ? false : reduced;
}
